import styled, { css } from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

export const StyledAuthorBadge = styled.div`
    display: flex;
    align-items: center;
    gap: ${getPurpurSpacing('100')};
`;

const authorImageBase = css`
    width: ${getPurpurSpacing('400')};
    height: ${getPurpurSpacing('400')};
    border-radius: ${getPurpurSpacing('400')};
`;

export const AuthorImage = styled.div`
    ${authorImageBase};
    position: relative;
    overflow: hidden;

    img {
        display: block;
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
`;

export const AuthorFallbackImage = styled.div`
    ${authorImageBase};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${getPurpurColor('backgroundToneOnTonePrimary')};
    color: ${getPurpurColor('functionalWhite')};

    svg {
        display: block;
    }
`;

export const AuthorName = styled.div`
    font-size: ${getPurpurTypography('scale100')};
    line-height: ${getPurpurTypography('lineHeightLoose')};
    font-weight: ${getPurpurTypography('weightMedium')};
    color: ${getPurpurColor('textDefault')};
    padding: ${getPurpurSpacing('150')} 0;
`;

export const BadgeLink = styled.a`
    text-decoration: none;
    outline: none;

    &:hover {
        ${AuthorName} {
            background-color: ${getPurpurColor('backgroundInteractivePrimaryHoverNegative')};
        }
    }

    &:active {
        ${AuthorName} {
            background-color: ${getPurpurColor('backgroundInteractivePrimaryActiveNegative')};
        }
    }

    &:focus-visible {
        ${AuthorName} {
            > div {
                outline: solid ${getPurpurBorder('widthSm')} ${getPurpurColor('borderInteractiveFocus')};
                outline-offset: ${getPurpurSpacing('25')};
            }
        }
    }
`;
